import { Component, OnInit, ViewChild } from '@angular/core';
import { isVisualizacaoModoDashboard, isVisualizacaoModoList, visualizacaoModoDashboard, visualizacaoModoList } from '../../../common/visualizacao-modo';
import { AuthService, ConfigService } from '../../../core';
import { ConfigEmpresa, isConfigEmpresaVersaoIntegracaoErp1 } from '../../configuracoes/app/empresa';
import { IntegrationRepresentanteModalComponent } from '../../configuracoes/integration/representante';
import { RepresentanteDashboardComponent } from './dashboard';
import { RepresentanteFilter, RepresentanteFilterComponent, RepresentanteFilterStorageService } from './filter';
import { RepresentanteImportModalComponent } from './import-modal';
import { RepresentanteListComponent } from './list';
import { RepresentanteOptions } from './representante-options';
import { representanteAtivo } from './situacao';
import { RepresentanteVisualizacao, RepresentanteVisualizacaoStorageService } from './visualizacao';

@Component({
    selector: 'sgt-representante',
    templateUrl: './representante.component.html',
    styleUrls: ['./representante.component.less']
})
export class RepresentanteComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    isIntegracaoErpV1: boolean;
    isAdministrador: boolean;

    // Filter
    filter = new RepresentanteFilter();
    @ViewChild('representanteFilter') representanteFilter: RepresentanteFilterComponent;
    orderBy: number;
    orderByDir: string;

    // Visualização
    readonly visualizacaoStorageKey = 'representanteVisualizacao';
    visualizacao = new RepresentanteVisualizacao();
    visualizacaoModos = [visualizacaoModoList, visualizacaoModoDashboard];

    @ViewChild('representanteImportModal') representanteImportModal: RepresentanteImportModalComponent;
    @ViewChild('integrationModal') integrationModal: IntegrationRepresentanteModalComponent;

    @ViewChild('list') list: RepresentanteListComponent;
    @ViewChild('dashboard') dashboard: RepresentanteDashboardComponent;

    // Options
    options: RepresentanteOptions;

    constructor(private authService: AuthService,
                private configService: ConfigService,
                private representanteVisualizacaoStorageService: RepresentanteVisualizacaoStorageService,
                private representanteFilterStorageService: RepresentanteFilterStorageService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isIntegracaoErpV1 = isConfigEmpresaVersaoIntegracaoErp1(this.configEmpresa);
        this.isAdministrador = this.authService.isAdministrador();
        this.createOptions();
        // Visualização
        this.visualizacao = this.representanteVisualizacaoStorageService.get(this.visualizacaoStorageKey);
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new RepresentanteOptions();
        // Importar
        this.options.canImportar = this.isAdministrador;
        // Importar do ERP V1
        this.options.canImportErp_v1 = this.canImportErp_v1();
    }

    private setStorage() {
        // Visualização
        this.representanteVisualizacaoStorageService.set(this.visualizacaoStorageKey, this.visualizacao);
        // Filter
        this.representanteFilterStorageService.set(this.filter);
    }

    /** Ao alterar o modo de visualização */
    onChangeVisualizacaoModo(modo: number) {
        this.visualizacao.modo = modo;
        setTimeout(() => this.search(), 0);
    }

    /** Verifica se o modo de visualização selecionado é o modo List */
    isVisualizacaoModoList(): boolean {
        return isVisualizacaoModoList(this.visualizacao?.modo);
    }

    /** Verifica se o modo de visualização selecionado é o modo Dashboard */
    isVisualizacaoModoDashboard(): boolean {
        return isVisualizacaoModoDashboard(this.visualizacao?.modo);
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.representanteFilterStorageService.hasFilter() || force) {
            this.filter.situacoes = [representanteAtivo.id];
        }
    }

    /** Ao iniciar o filtro */
    onFilterInitialized() {
        this.setDefaultFilters();
        this.search();
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters(true);
        this.search();
    }


    search() {
        this.setStorage();

        if (this.isVisualizacaoModoDashboard()) { // Dashboard
            this.dashboard?.load();
        } else if (this.isVisualizacaoModoList()) {
            this.list?.search();
        }
    }


    /** Atualizando a pesquisa */
    refresh() {
        if (this.isVisualizacaoModoDashboard()) { // Dashboard
            this.dashboard?.load();
        } else if (this.isVisualizacaoModoList()) {
            this.list?.refresh();
        }
    }

    /** Abre o modal para importar os representantes */
    openImportModal() {
        this.representanteImportModal.open();
    }

    onAfterImport() {
        this.search();
    }

    /** Verifica se pode importar os representantes do ERP V1 */
    private canImportErp_v1(): boolean {
        // Somente se for a versão 1
        if (!this.isIntegracaoErpV1) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

    /** Abre o modal para realizar a importação dos representantes do ERP V1 */
    openIntegracaoErpImportModal_v1() {
        this.integrationModal.open();
    }

    /** Após realizar a importação dos representante do ERP V1 */
    afterImportErp_v1() {
        this.refresh();
    }
}
